






































import {Component, Prop, Watch, Provide, Vue} from 'vue-property-decorator'
import {$, Helper} from 'simpli-web-sdk'
import {CargaSaraiva} from '@/model/resource/CargaSaraiva'
import {InputCargaSaraivaSchema} from '@/schema/resource/CargaSaraiva/InputCargaSaraivaSchema'

@Component
export default class PersistCargaSaraivaView extends Vue {
  @Prop() id?: string

  @Provide('validator') validator = this.$validator

  schema = new InputCargaSaraivaSchema()
  cargaSaraiva = new CargaSaraiva()

  async created() {
    await this.populate()
  }

  async populate() {
    const id = Number(this.id) || null

    if (id) {
      await this.cargaSaraiva.getCargaSaraiva(id)
    }

    $.await.done('getCargaSaraiva')
  }

  async persist() {
    const isValid = await this.validator.validateAll()

    if (!isValid) {
      Helper.abort('system.error.validation')
    }

    await this.cargaSaraiva.persistCargaSaraiva()
    await Helper.successAndPush('system.success.persist', '/carga-saraiva/list')
  }
}
